'use strict';

bbw.model.PostCounters = ngtk.model.Item.extend({

    load: function(userId) {
        return this._loadFromApi('get', 'posts/count/' + (userId || '')).then(function(response) {
            this._setFromApiResult(response.counters);
        }.bind(this));
    }

});
